import React, { useEffect, useState, Fragment } from 'react';
import Layout from 'components/sales/layout/layout';
import TableSection from 'components/sales/tableSection/tableSection';
import { ArrowRight, Filter, tick } from 'assets/images/imageData';
import localization from 'assets/localization/localization';
import ListFilters from 'components/sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import ModalPop from 'components/sales/modal/modal';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from 'assets/images/imageData';
import AdvancePayment from 'components/sales/paymentPortal/addAdvance/addAdvancePopup';
import AddPaymentPopup from "components/sales/paymentPortal/addPayment/addPaymentPopup";
import AdjustAdvancePopup from "components/sales/paymentPortal/adjustAdvance/adjustAdvancePopup";
import PaymentFilter from 'components/sales/ListFilters/PaymentFilter';


const PaymentRequest = ({
  getPaymentRequest,
  postSalesList,
  getListFilterData,
  filterDropdownList = null,
  fetchZones,
  getFetchZones = null,
}) => {
  const headers = [
    'Request Id',
    'Invoice Number',
    'Business Name',
    'Requested Date',
    'Type',
    'Payment Mode',
    'Amount',
    'TDS',
    'Transaction Date',
    'Request Status',
    'Status',
    'Actions',
  ];
  const [listData, setListData] = useState();
  const [activePostSales, setActivePostSales] = useState();
  const [teamId, setTeamId] = useState();
  const [departmentId, setDepartmentId] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const [filterData, setFilterData] = useState(null);
  const [showFilter, setShowFilter] = useState(false);
  const [isStatusSuccess, setIsStatusSuccess] = useState(false);
  const [isRoleId, setIsRoleId] = useState(null);
  const [showAddAdvancePopup, setShowAddAdvancePopup] = useState(false);
  const [showAddPaymentPopup, setShowAddPaymentPopup] = useState(false);
  const [showAdjustAdvancePopup, setShowAdjustAdvancePopup] = useState(false);
  const [currentBusinessId, setCurrentBusinessId] = useState('');
  const [currentInvoiceId, setCurrentInvoiceId] = useState('');
  const [currentContractId, setCurrentContractId] = useState('');
  const [currentSiteNumber, setCurrentSiteNumber] = useState('');
  const [currentRowData, setCurrentRowData] = useState();
  const [currentBusinessName, setCurrentBusinessName] = useState('');
  const [isView, setIsView] = useState(false);
  const [isEdit, setIsEdit] = useState(false);

  useEffect(() => {
    (async () => {
      const roles = await JSON.parse(localStorage.getItem('roles'));
      roles && setIsRoleId(roles[0].pivot.role_id);
    })();
  }, []);

  const createLead = async () => {
    if (departmentId && departmentId === 2) {
      if (teamId && teamId === 7) {
        setActivePostSales('post-sales-corporate');
      } else if (teamId && teamId === 9) {
        setActivePostSales('post-sales-supply');
      } else if (teamId && teamId === 8) {
        setActivePostSales('post-sales-apartment');
      } else {
        setActivePostSales('post-sales-b2b-alliance');
      }
    }
  };

  useEffect(() => {
    (async () => {
      const team =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].team_id;
      const deparment =
        (await JSON.parse(localStorage.getItem('profileDetails'))) &&
        JSON.parse(localStorage.getItem('profileDetails'))[0].department_id;
      setTeamId(team);
      setDepartmentId(deparment);
    })();
  }, []);

  useEffect(() => {
    if (teamId && departmentId) {
      createLead();
    }
  }, [teamId, departmentId]);

  useEffect(() => {
    if (getPaymentRequest !== null) {
      (async () => {
        setIsLoading(true);
        const dashBoardFilter = await JSON.parse(
          localStorage.getItem("dashBoardFilter") &&
            localStorage.getItem("dashBoardFilter")
        );
        setFilterData({
          invoice_no:'',
          client_name:'',
          invoice_no:'',
          action_status: (dashBoardFilter && dashBoardFilter.action_status)?dashBoardFilter.action_status:'',
          request_type: (dashBoardFilter && dashBoardFilter.request_type)?dashBoardFilter.request_type:'',
          fromDate: (dashBoardFilter && dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
          toDate: (dashBoardFilter && dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
        });
        await getPaymentRequest({
          invoice_no:'',
          client_name:'',
          invoice_no:'',
          action_status: (dashBoardFilter && dashBoardFilter.action_status)?dashBoardFilter.action_status:'',
          request_type: (dashBoardFilter && dashBoardFilter.request_type)?dashBoardFilter.request_type:'',
          fromDate: (dashBoardFilter && dashBoardFilter.fromFilterDate)?dashBoardFilter.fromFilterDate:'',
          toDate: (dashBoardFilter && dashBoardFilter.toFilterDate)?dashBoardFilter.toFilterDate:'',
        }, 1);
        setIsLoading(false);
        localStorage.setItem("dashBoardFilter", JSON.stringify(''));
      })();
    }
  }, [getPaymentRequest]);

  useEffect(() => {
    const tableData = [
      'request_id',
      'invoice_number',
      'business',
      'request_date',
      'request_type',
      'payment_mode',
      'amount',
      'tds',
      'transaction_date',
      'request_status',
      'action_status',
     
    ];

    if (postSalesList !== {} && postSalesList.resultSets) {
      const data = postSalesList.resultSets.map((element) =>
      
      Object.assign(
        {},
        ...tableData.map((key) => ({ [key]: element[key] })),
        
        (element?.action_status === 'PENDING' || element?.action_status === 'HOLD') ? {
          Action: [
            { name: 'Edit Request', rowData: element },
            { name: 'View Request', rowData: element },
          ],
        } : {
          Action: [
            { name: 'View Request', rowData: element },
          ],
        }
      )

      );
      data && setListData(data);
      setPageCount(Math.ceil(postSalesList.total / postSalesList.per_page));
    }
  }, [postSalesList]);

  const applyFilter = async (filterData) => {
    setIsLoading(true);
    setFilterData(filterData);
    await getPaymentRequest(filterData, 1);
    setIsLoading(false);
    filterToggle();
  };

  useEffect(() => {
    (async () => {
      await getListFilterData(2);
    })();
  }, []);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const headerBtns = () => {
    return (
      <Fragment>
         <Button
          onClick={filterToggle}
          className="filter-hamburger btn btn-transparent"
        >
          {/* <img src={Images?.Filter} alt="" /> */}
          {localization.showFilters}
        </Button> 
      </Fragment>
    );
  };

  const onPageChange = async (val) => {
    let filter = filterData === null ? null : filterData;
    setIsLoading(true);
    await getPaymentRequest(filter, val.selected + 1);
    setIsLoading(false);
  };

  const getZones = (val) => {
    if (val) fetchZones(val);
  };

  const closeSuccess = () => {
    setIsLoading(true);
    setIsStatusSuccess(!isStatusSuccess);
    setIsLoading(false);
  };

  return (
    <Layout
      title={localization.PaymentRequestList}
      Buttons={headerBtns}
      isLoading={isLoading}
    >
      <TableSection
        data={listData}
        isId={false}
        headers={headers}
        detailList={postSalesList && postSalesList.resultSets}
        pageCount={pageCount}
        srNo={postSalesList?.from}
        onPageChange={onPageChange}
        setShowAddAdvancePopup={setShowAddAdvancePopup}
        setShowAddPaymentPopup={setShowAddPaymentPopup}
        setShowAdjustAdvancePopup={setShowAdjustAdvancePopup}
        setCurrentBusinessId={setCurrentBusinessId}
        setCurrentContractId={setCurrentContractId}
        setCurrentInvoiceId={setCurrentInvoiceId}
        setCurrentSiteNumber={setCurrentSiteNumber}
        setCurrentBusinessName={setCurrentBusinessName}
        setCurrentRowData={setCurrentRowData}
        setIsView={setIsView}
        setIsEdit={setIsEdit}
      />

      <PaymentFilter
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        statusId={'5'}
        getZones={(val) => getZones(val)}
        listFilterData={filterDropdownList && filterDropdownList.data}
        zones={getFetchZones && getFetchZones.data}
        isRoleId={isRoleId}
        paymentRequestFilter
      />

      {showAddAdvancePopup && <AdvancePayment
        showAdvancePopup={showAddAdvancePopup}
        onClosePopup={() => setShowAddAdvancePopup(false)}
        businessId={currentBusinessId}
        invoiceId={currentInvoiceId}
        contractId={currentContractId}
        siteNumber={currentSiteNumber}
        businessName={currentBusinessName}
        rowData={currentRowData}
        isEdit={isEdit}
        isView={isView}
      />}

      {showAddPaymentPopup && <AddPaymentPopup
        showPaymentPopup={showAddPaymentPopup}
        onClosePopup={() => setShowAddPaymentPopup(false)}
        businessId={currentBusinessId}
        invoiceId={currentInvoiceId}
        contractId={currentContractId}
        siteNumber={currentSiteNumber}
        businessName={currentBusinessName}
        rowData={currentRowData}
        isEdit={isEdit}
        isView={isView}
      />}

      {showAdjustAdvancePopup && <AdjustAdvancePopup
        showAdjustAdvancePopup={showAdjustAdvancePopup}
        onClosePopup={() => setShowAdjustAdvancePopup(false)}
        businessId={currentBusinessId}
        invoiceId={currentInvoiceId}
        contractId={currentContractId}
        siteNumber={currentSiteNumber}
        businessName={currentBusinessName}
        rowData={currentRowData}
        isEdit={isEdit}
        isView={isView}
      />}
    </Layout>
  );
};

export default PaymentRequest;
